export default __webpack_public_path__ + "images/P0.3180828.png";